export const Accordion = () => {

    function toggleAccordion(event) {
        const accordion = event.target.closest('.accordion');
        if (accordion) {
            accordion.classList.toggle('accordion--active');
        }
    }

    const accordionHeaders = document.querySelectorAll('.accordion__header');
    accordionHeaders.forEach(header => {
        header.addEventListener('click', toggleAccordion);
    });
}